import { SurfaceMaterialModel } from '@seddi/surface-material';

export const SHADING_MODEL_DEFAULT = SurfaceMaterialModel.DISNEY;
